<template>
  <div>
    <main>
      <div class="appInfo">
        <p>应用名称：东航期货APP</p>
        <p>开发者名称：东航期货有限责任公司</p>
        <p>最新更新日期：2026年02月03日</p>
        <p>上次更新日期：2026年01月12日</p>
        <p>
          尊敬的东航期货App用户（以下简称“您”），欢迎您使用东航期货App（以下简称“本App”）服务，东航期货有限责任公司（以下简称“东航期货”或“我们”）非常重视您的隐私保护和个人信息保护。本风险提示和隐私条款（以下简称“本条款”）适用于您通过任何方式使用东航期货App的各项服务。
        </p>
        <p>
          在您使用东航期货App各项产品或服务前，请您仔细阅读本条款并确定了解我们对您个人信息的处理规则。如您选择同意本条款，或者使用或继续使用本App，即意味着您同意本条款，并同意我们按照本条款收集、使用、储存和对外提供您的相关信息；如您不同意本条款中的任何条款，您应立即停止访问和使用本App。
        </p>
      </div>
      <ul>
        <li class="dis-flex">
          <i class="left-line"></i>
          <h4 class="flex-1">一、电子交易风险揭示</h4>
        </li>

        <li>
          1.政策风险
          <p>
            国家法律法规、政策、规章的变化，期货交易所紧急措施、相关条例规定的出台，相关监管部门监管措施的实施等原因，均会对客户的交易产生影响，交易客户必须自行承担由此导致的损失。
          </p>
        </li>

        <li>
          2.不可抗力风险
          <p>
            任何因我司无法预见、不能避免的原因：包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、黑客、网路堵塞、电信部门技术调整等事件。上述因素都会对交易客户的交易产生影响，交易客户必须自行承担由此导致的损失。
          </p>
        </li>
        <li>
          3.技术风险
          <p>
            （1）
            由于互联网数据传输的特殊性，存在被网络黑客或计算机病毒攻击的可能，有通讯服务及软件服务器稳定性方面的风险等原因，买卖指令及行情等信息可能会出现终端、停顿、延迟及数据错误等异常情况，非因我司原因引起的损失，交易客户必须自行承担相应损失。
          </p>
          <p>
            （2）
            由于我司在进行服务器配置、维护时所需要的短时间中断服务或由于Internet上的通路阻塞造成客户网站访问、应用或服务运行等的速度下降。此类原因造成的损失，交易客户须自行承担。
          </p>
        </li>
        <li>
          4.价格波动风险
          <p>
            期货价格受多种因素影响（包括但不限于国际经济走势、美元汇率、市场走势、政治局势、自然因素等），客户须充分了解期货市场交易中价格变动风险，有效控制风险以避免遭受较大损失。否则，交易客户将自行承担由此导致的一切损失。
          </p>
        </li>
        <li>
          5.交易风险
          <p>
            （1）
            交易客户了解期货交易的保证金制度与高杠杆比例的交易特点，可能导致快速盈利或亏损。根据行情波动、期交所相应保证金比率要求结合客户权益等数据，交易客户必须有条件满足随时追加保证金的要求，以降低客户自身风险度。否则我司将按规定对其持仓进行强行平仓，交易客户须自行承担一切损失。
          </p>
          <p>
            （2）
            交易客户通过网络终端所提交的市价单一旦成交即不可撤销，客户须接受这种方式可能带来的风险。
          </p>
        </li>
        <li>
          6.特别提示
          <p>
            （1）
            客户已阅读并充分理解上述风险，了解期货交易“风险自担”、“高杠杆率、高风险”的特点。
          </p>
          <p>
            （2）
            此项服务及其内容所包含的所有数据和信息仅供参考，并非建议或暗示用户做任何有关投资或理财的决定，用户所做的任何交易决定应自行负责。
          </p>
          <p>
            （3）
            本公司授权用户在协议约定的服务期限内可以使用本软件及随本软件提供的服务。本软件作为客户端软件，是整体软件系统的一个组成部分；任何情况下，本公司不向任何客户转让本软件的所有权。
          </p>
        </li>
      </ul>

      <ul>
        <li class="dis-flex">
          <i class="left-line"></i>
          <h4 class="flex-1">二、责任限制</h4>
        </li>
        <li>
          1.我司对客户提供的软件数据服务均为免费使用，客户应理解我司会对服务可用性和可靠性提供支撑，但并不对任何服务可用性、可靠性做出承诺。在法律许可的范围内，我司将不会对任何间接性、惩罚性的损害，包括客户因使用该服务遭受的预期利润或间接损失承担责任。
        </li>
        <li>
          2.在法律许可的范围内，我司全部赔偿责任在任何情况下不得超过客户向我司实际支付的全部许可使用费用。
        </li>
      </ul>

      <ul>
        <li class="dis-flex">
          <i class="left-line"></i>
          <h4 class="flex-1">三、软件服务及隐私条款</h4>
        </li>
        <li>
          本App主要提供两类功能：1. 一般使用者用于浏览期货行情和相关资讯信息；
          2.
          东航期货客户进行期货交易、开户及业务办理等相关服务。如您不同意本条款的任何内容或者无法理解相关内容，请不要进行后续操作。若您开始使用本App，即表示您已充分理解并同意本条款的全部内容。
        </li>
        <li>本条款将帮助您了解以下内容：</li>
        <li>1. 我们收集哪些信息</li>
        <li>2. 我们如何使用Cookie和同类技术</li>
        <li>3. 我们如何存储您的信息</li>
        <li>4. 我们如何保护您的信息</li>
        <li>5. 我们如何处理您的信息</li>
        <li>6. 您的权利</li>
        <li>7. 未成年人保护</li>
        <li>8. 通知和变更</li>
        <li>9. 与我们联系</li>
      </ul>
      <ul>
        <li>具体内容如下：</li>
        <li>1. 我们收集哪些信息</li>
        <li>
          个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
        </li>
        <li>
          敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
        </li>
        <li>
          在您使用本App的过程中，请您注意：根据相关法律法规，以下情形中，我们可能会处理您的个人信息而无需征得您的授权同意：
        </li>
        <li>
          （1）为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；
        </li>
        <li>（2）为履行法定职责或者法定义务所必需；</li>
        <li>
          （3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
        </li>
        <li>
          （4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
        </li>
        <li>
          （5）依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
        </li>
        <li>（6）法律、行政法规规定的其他情形。</li>
        <li>
          在您日常使用本App的过程中，我们会按照如下方式收集您在使用服务时主动提供或因为使用服务而产生的信息，或请求调取您设备中的某项隐私权限，以用于为您提供相应的服务：
        </li>
        <li>1.1 一般信息收集</li>
        <li>
          1.1.1
          当您使用本App时，为保证您能正常使用我们的服务，我们会根据相关法律法规的要求，以及优化您的服务体验及保障您账户安全的需要收集您的信息，包括读取剪切板、您的设备型号、操作系统版本、IMEI、Android
          id、IDFA、IDFV、公网IP、公网IP端口号、内网IP、MAC地址、WiFi的SSID和BSSID、本App软件版本号，此类信息是为您提供服务时必需收集的基础信息。若您不同意提供该信息，请勿继续使用本App。
        </li>
        <li>
          1.1.2
          当您使用意见反馈功能时，我们会将您的账号（仅针对登录客户）、设备认证手机号码、具体反馈意见、设备型号、及上传的图片信息存储于后台服务器中，以便客服人员更好的处理您的问题，或在需要的情况下与您取得联系。若您不同意提供该信息，请勿使用意见反馈功能。您可通过其它途径反馈您的意见。
        </li>
        <li>
          1.1.3
          当您使用在线客服功能时，我们会将您的账号（仅针对登录客户）、设备认证手机号码、具体反馈意见、设备型号、及上传的图片信息存储于后台服务器中，以便客服员答复您的提问。若您不同意提供上述信息，将无法使用在线客服功能，但不影响您使用其他服务。
        </li>

        <li>1.2 开户及登录信息收集</li>
        <li>
          1.2.1
          当您使用手机号注册本App时，根据相关法律法规的网络实名制要求，您需要验证您的手机号码。若您不同意提供该信息，将无法使用需注册手机账号后才可使用的各项功能，但不影响您使用本App的其他功能。
        </li>
        <li>
          1.2.2
          根据<strong>《期货公司互联网开户规则》</strong>，用户进行期货账户互联网开户申请时，必须提交身份证正反面照片、客户免冠照、证明客户实名开户及开户意愿的视频（单向或双向）。当您通过本App线上开户时，我们将根据监管机构要求收集您的<span
            class="underline"
            >个人身份信息、个人账户信息及办理网上开户业务所需的其他信息，包括您的姓名、住址、联系方式、证件有效期、证件类型、证件号码、证件地址、工作类型、学历、财务状况、诚信记录、银行卡号</span
          >。并根据监管机构机构要求，将您填写的<span class="underline"
            >个人身份信息、个人基本信息或银行卡信息报送至中国期货市场监控中心有限责任公司</span
          >，以便根据您的申请为您建立期货账户。请注意，我们仅报送相关机构所必须的信息，且仅用于办理相关开户业务。除非您自主选择或遵从相关法律法规要求，我们不会对外提供上述信息，也不会将其用于开户以外的其他用途。
        </li>
        <li>
          1.2.3
          当您使用涉及面容识别认证的业务办理功能时，我们会将您每次使用服务时拍摄的面部识别照片和视频信息存储于后台服务器中，作为您的用户日志存档。若您不同意提供该信息，将无法通过面容识别认证的方式办理相应业务，但不影响您通过其它路径办理业务。
        </li>
        <li>1.3 行情交易</li>
        <li>
          1.3.1
          为了您能够使用期货行情交易功能，我们使用了博易SDK。当您使用期货行情交易功能时，您需要提供您的期货账户，我们会根据监管<strong>看穿式监管要求</strong>获取您的手机设备信息并向监管机构报送（安卓：<span
            class="underline"
            >终端类型、移动终端IP、地理位置信息、操作系统版本、设备名称、设备类型、IMEI1、IMEI2、MEID、MAC地址、手机号码、设备序列号、IMSI、ICCID、公网IP、公网端口号</span
          >；iOS：<span class="underline"
            >终端类型、移动终端IP、地理位置信息、操作系统版本、设备名称、设备类型、网络运营商、UUID、公网IP、公网端口号、Device Token、 Device Id）</span
          >。如果您不同意提供上述信息，您可以选择不使用博易SDK。根据监管要求，我们将无法向您提供行情交易服务，但不影响您使用我们提供的其他服务。当您在开始使用本App的行情交易功能后，若您不再同意您的相关设备信息被继续获取收集，您也可以选择暂停使用博易SDK。您选择暂停使用后，博易将停止获取您的个人信息，但该行为将导致您无法继续使用本App提供的行情交易服务。
        </li>
        <li>
          1.3.2
          当您开启使用指纹/人脸识别快捷登录交易功能时，我们需要验证您的指纹/人脸数据。请知悉，我们<span
            class="underline"
            >不会直接读取您的指纹/人脸数据</span
          >，而是通过设备操作系统底层提供的安全接口采集相关特征信息，您的指纹/人脸原始数据均由设备操作系统保存在您设备的安全储存区域。若您不同意提供此信息，您可以关闭指纹/面容识别快捷登录功能，选择使用其它方式（如手动输入期货账号和密码）登录。
        </li>
        <li>
          1.3.3
          为了及时向您提供条件单、预警离线推送以及资讯信息，我们需要收集终端设备UUID、推送DeviceToken。
        </li>
        <li>
          1.3.4
          当您使用行情交易中的云条件单、画线下单、自选合约同步等功能时，需要注册登录博易行情账号，账号使用手机号登录。当您注册时，我们会收集您的手机号码、本机IP、UUID和<span
            class="underline"
            >Device Id</span
          > ，并向您发送短信验证码，以验证您的身份。手机号码属于敏感个人信息，收集手机号码是为了帮助您完成注册，保护您的账户安全。若您不提供此类信息，您将无法使用行情交易中的相关服务。
        </li>
        <li>1.4 其它业务办理</li>
        <li>
          当您使用本App进行其他业务办理时，根据不同业务的需要，您可能需要提供以下信息：<span
            class="underline"
            >身份证正反面照片、客户免冠照、证明您真实意愿的视频（单向或双向）、您的手机设备信息、通信信息、账号信息、身份信息、职业、联系地址、收入</span
          >以保证相应业务的顺利完成。若您拒绝提供相关信息，我们将无法为您提供相应的业务办理服务，但不影响您使用我们提供的其他服务。
        </li>
        <li>信息及权限获取场景：</li>
        <table border="1" cellspacing="0">
          <tr>
            <th style="width: 20%; text-align: center">业务功能</th>
            <th style="width: 20%; text-align: center">业务场景</th>
            <th style="width: 30%; text-align: center">场景说明</th>
            <th style="width: 30%; text-align: center">访问及使用权限</th>
          </tr>
          <tr>
            <td>注册</td>
            <td>注册账号</td>
            <td>通过手机号、验证码、密码登录账号</td>
            <td>/</td>
          </tr>
          <tr>
            <th rowspan="2">登录</th>
            <td>验证码登录</td>
            <td>通过手机号、验证码登录账号</td>
            <td>访问设备信息权限获取手机号</td>
          </tr>
          <tr>
            <td>密码登录</td>
            <td>通过手机号、密码登录账号</td>
            <td>/</td>
          </tr>
          <tr>
            <td>忘记登录密码（重置密码）</td>
            <td>重置密码</td>
            <td>通过手机号、验证码、密码验证，保障账号安全</td>
            <td>/</td>
          </tr>
          <tr>
            <td>交易登录</td>
            <td>登录账号</td>
            <td>
              通过账号、交易密码登录资金账号；IOS可通过面容识别登录资金账号
            </td>
            <td>
              根据看穿式监管要求获取设备信息权限、位置权限；IOS通过获取Face
              ID来进行身份验证以实现面容识别登录功能
            </td>
          </tr>
          <tr>
            <td>安全设置</td>
            <td>修改手机号</td>
            <td>校验验证码以保障账号安全</td>
            <td>/</td>
          </tr>
          <tr>
            <th rowspan="2">个人资料</th>
            <td>账号信息</td>
            <td>显示用户头像、昵称、手机号</td>
            <td>/</td>
          </tr>
          <tr>
            <td>修改密码</td>
            <td>通过校验原密码以保障账号安全，并收集需要更换的新密码</td>
            <td>/</td>
          </tr>
          <tr>
            <td>兑换万里行积分</td>
            <td>兑换积分</td>
            <td>通过您的姓名查询您的万里行账号以兑换积分</td>
            <td>/</td>
          </tr>
          <tr>
            <td>我的账户-报名参赛</td>
            <td>盟军报名</td>
            <td>
              收集您的姓名、身份证号、手机号、电话、电子邮箱、期货公司、联系地址、保证金监控中心账号、保证金监控中心密码进行参赛
            </td>
            <td>/</td>
          </tr>
          <tr>
            <td>我的客服</td>
            <td>咨询问题</td>
            <td>-</td>
            <td>
              安卓：获取相机、存储权限以达到您可以拍照或上传需要沟通的内容
              苹果：读取和写入用户照片库权限以达到您可以拍照或上传需要沟通的内容
            </td>
          </tr>
          <tr>
            <td>意见反馈</td>
            <td>反馈问题</td>
            <td>收集您的手机号或邮箱或QQ以反馈您提交的问题</td>
            <td>/</td>
          </tr>
          <tr>
            <td>开户</td>
            <td>-</td>
            <td>收集姓名、手机号、验证码以确认开户人身份</td>
            <td>/</td>
          </tr>
          <tr>
            <th rowspan="7">极速开户</th>
            <td>开立期货账户</td>
            <td>收集身份证号校验身份</td>
            <td>/</td>
          </tr>
          <tr>
            <td>开立资管账户</td>
            <td>收集身份证号校验身份</td>
            <td>/</td>
          </tr>
          <tr>
            <td>增加交易编码</td>
            <th rowspan="5">收集身份证号、验证码校验身份</th>
            <td rowspan="5">/</td>
          </tr>
          <tr>
            <td>适当性评估</td>
          </tr>
          <tr>
            <td>我的基本资料</td>
          </tr>
          <tr>
            <td>修改结算账户</td>
          </tr>
          <tr>
            <td>协议下载</td>
          </tr>
          <tr>
            <td>结算单查询</td>
            <td>查询交易结算单</td>
            <td>收集用户名、密码、验证码以校验身份</td>
            <td>/</td>
          </tr>
          <tr>
            <th rowspan="16">业务办理</th>
            <td>交易权限开通、账户激活</td>
            <td>/</td>
            <td>/</td>
          </tr>
          <tr>
            <td>适当性评估</td>
            <td>/</td>
            <td>/</td>
          </tr>
          <tr>
            <td>仿真期货开户（仿真申请）</td>
            <td>根据监管要求收集姓名、身份证号、邮件地址</td>
            <td>/</td>
          </tr>
          <tr>
            <td>信息修改-身份证件号更新</td>
            <td>收集身份证照片、身份证号以更新账号信息</td>
            <td>
              安卓：获取相机、存储权限以达到您可以拍照或上传最新身份证照片
              苹果：读取和写入用户照片库权限以达到您可以拍照或上传最新身份证照片
            </td>
          </tr>
          <tr>
            <td>信息修改-手机号修改</td>
            <td>收集并校验留存手机号验证码以保障账户安全并更新账号信息</td>
            <td>/</td>
          </tr>
          <tr>
            <td>信息修改-电子邮箱修改</td>
            <td>收集需要修改的邮箱进行账号信息更新</td>
            <td>/</td>
          </tr>
          <tr>
            <td>信息修改-职业修改</td>
            <td>收集需要修改的职业进行账号信息更新</td>
            <td>/</td>
          </tr>
          <tr>
            <td>忘记密码- 忘记交易密码</td>
            <td>收集并校验姓名、资产账号、身份证号以确保账号安全</td>
            <td>/</td>
          </tr>
          <tr>
            <td>忘记密码- 忘记资金密码</td>
            <td rowspan="2">收集并校验交易密码以确保账号安全</td>
            <td>/</td>
          </tr>
          <tr>
            <td>忘记密码- 忘记保证金监控中心密码</td>
            <td>/</td>
          </tr>
          <tr>
            <td>证件更新</td>
            <td>收集身份证照片、身份证号以更新账号信息</td>
            <td>
              安卓：获取相机、存储权限以达到您可以拍照或上传最新身份证照片
              苹果：读取和写入用户照片库权限以达到您可以拍照或上传最新身份证照片
            </td>
          </tr>
          <tr>
            <td>银行账户-变更/新增银行卡</td>
            <td>
              收集需要更换或新增的银行卡信息进行账号信息更新；收集并校验密码以确保账号安全
            </td>
            <td>
              安卓：获取相机、存储权限以达到您可以拍照或上传变更或新增的银行卡信息
              苹果：读取和写入用户照片库权限以达到您可以拍照或上传变更或新增的银行卡信息
            </td>
          </tr>
          <tr>
            <td>交易权限</td>
            <td>/</td>
            <td>/</td>
          </tr>
          <tr>
            <td>我的保证金</td>
            <td>/</td>
            <td>/</td>
          </tr>
          <tr>
            <td>文件下载</td>
            <td>收集您的联系邮箱来发送您需要下载的文件</td>
            <td>/</td>
          </tr>
          <tr>
            <td>盟军绑定</td>
            <td>收集保证金监控中心账号、保证金监控中心密码以确认绑定的账号</td>
            <td>/</td>
          </tr>
          <tr>
            <td>信息推送</td>
            <td>信息推送</td>
            <td>推送您订阅的信息或交易情况</td>
            <td>
              当我们需要向您推送消息时，需要获取您消息通知的权限以及消息震动并唤醒屏幕的权限，同时为了及时提醒您相关交易委托的实时交易情况，需要获取您系统级警报(悬浮窗)权限
            </td>
          </tr>
          <tr>
            <td>实名认证</td>
            <td>业务办理</td>
            <td>
              实名认证：姓名、身份证号码、人脸照片或视频。身份证OCR/NFC：身份证图片，及图片上的性别、民族、出生日期、住址、签发机关、有效期；意愿认证：声纹/语音文件
            </td>
            <td>
              在最终用户同意开启相机/摄像头/录屏/麦克风权限后，我们会在您完成指定验证动作时，获取最终用户的姓名、身份证号、人脸图片和视频流进行用于检查真实人脸、进行身份验证比对。此外，当您使用实人认证OCR功能时，我们还将通过最终用户拍照上传的身份证图片（正面）获取最终用户的姓名、性别、民族、出生日期、住址、身份证号码等身份信息，以进行安全验证；当您使用多因子意愿认证功能时，我们将通过最终用户录制并上传的音视频文件获取最终用户的语音信息及声纹特征。您及最终用户知晓，即使最终用户已同意开启相机权限，我们也仅会在最终用户主动点击客户端内相机图标或录制视频时通过相机获取照片信息。
            </td>
          </tr>
        </table>
        <li>1.5 权限及数据获取</li>
        <li>
          在您使用以下功能前，本App会根据服务需要申请调用您设备的摄像头权限、读写外部存储权限、麦克风权限、定位权限、指纹/面容识别数据、设备信息权限（仅android系统，ios系统的设备信息权限除外）、手机短信权限及电话权限，在您主动同意授权之前，我们不会获取您的任何权限。但若您已经同意我们获取您的这些权限，我们在为您提供下文中提及的需要相同权限的服务时，将不会再次请求调用您的相应权限，并默认获取该权限。若您不希望我们继续获取您的某项权限，可以随时前往您的设备设置中关闭已对本App开启的隐私权限。请注意，上述权限为提供服务所必须，除为您提供以下服务的目的之外，我们不会随意调用您的权限。若您不同意授权某项权限，将无法继续使用相应功能，但不影响您使用本App的其它功能。
        </li>
        <li>1.5.1 摄像头权限</li>
        <li>
          （1）当您使用本App线上开户功能及部分线上业务办理功能时，我们会根据监管要求和业务需求请求调用您的设备摄像头权限。
        </li>
        <li>
          （2）当您使用涉及面容识别认证的业务办理功能时，我们会请求调用您设备的摄像头权限，以识别您的面部信息。
        </li>
        <li>1.5.2 读写外部存储权限</li>
        <li>
          当您使用手机开户功能及部分线上业务办理功能中的上传证件功能时，我们会请求调用您设备的读写外部存储权限，以调取您需要上传的照片。
        </li>
        <li>1.5.3 麦克风权限</li>
        <li>
          当您使用本App线上开户功能及部分线上业务办理功能时，我们会根据监管要求和业务需求请求调用您设备的麦克风权限。
        </li>
        <li>1.5.4 定位权限</li>
        <li>
          当您使用期货交易功能时，我们会根据监管机构看穿式监管要求，调用您定位权限以获取您的精准定位的信息（GPS信息）。若您不同意我们调用您的该权限，您将无法使用交易功能。
        </li>
        <li>1.5.5 设备信息权限</li>
        <li>
          若您使用的设备为android系统，当您在本App进行手机号码注册或账户登录时，我们会申请获取您的设备权限。依据监管要求，设备权限中的设备信息
          是您进行账户注册、登录、交易、理财、转帐、资产查询及部分业务办理功能所必须，我们获取您的设备权限后，将在您进行前述操作时直接获取您的设备信息，设备信息
          包含您的硬件型号、操作系统版本、设备配置、唯一设备标识符、IMEI、MAC地址，若您不同意授权，将无法在本App中进行前述操作。（ios系统因系统自身原因，我们将在您进行手机号码注册或账户登录默认获取您的设备权限，若您不同意授权，可选择不进行前述操作）。
        </li>
        <li>
          请您理解，我们向您提供的功能和服务将会不断更新和优化，若某一功能未能在前述说明中概括，并且需要获取您的权限，我们将会通过页面提示、交互流程、网站公告等方式另外向您说明信息收集的目的、内容、范围和用途。
        </li>
        <li>1.5.6手机短信权限</li>
        <li>
          当您使用本App进行信息分享的时候，选择了通过短信途径进行分享，我们将会调用您的手机短信发送功能，进行信息分享。若您不同意我们调用该权限，您将无法使用通过短信途径分享的功能。
        </li>
        <li>1.5.7电话权限</li>
        <li>
          当您使用本APP电话客服功能拨打客服电话4008-889-889时，我们需要获取您设备的通话功能权限来拨打客服电话，若您不同意我们调用您的该权限，您将无法使用此功能呼叫4008-889-889。
        </li>
        <li>1.6 三方服务软件的信息采集</li>
        <li>
          （1）当您使用本App的各项服务时，在某些特定使用场景下，我们可能会使用具有相应业务资质及能力的第三方服务商提供的软件工具开发包（以下简称“SDK”）来为您提供服务。我们会尽到审慎义务，对其安全性进行综合评估。
        </li>
        <li>
          当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到由第三方服务商收集您的个人信息，建议您仔细查看第三方主体的隐私政策条款或协议约定。
        </li>
        <li>
          目前东航期货App接入的第三方SDK详见：<span class="red" @click="godsf">
            《东航期货APP第三方信息共享清单》
          </span>
          <div></div>
        </li>

        <li>
          如您不同意上述第三方服务商收集前述信息，可能无法获得相应服务，但不影响您正常使用本App的其他功能或服务。如您同意上述相关第三方服务商收集前述信息发生信息泄露的，由相关第三方服务商承担相应的法律责任。
        </li>

        <li></li>

        <li>（2）自启动和关联启动说明</li>
        <li>
          1.极光推送SDK具有自启动功能，为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为,是因实现功能及服务所必要的。本应用须使用(自启动)能力，其目的是确保推送通道的稳定性，以便正常及时地向设备推送消息。当系统发送广播时，将唤醒极光推送SDK自启动行为。鉴于极光推送SDK系以集成方式接入应用，极光推送SDK自启动，则应用伴随之自启动。该行为系因实现推送功能及服务所必要。
        </li>
        <li>
          2、当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。
        </li>
        <li>3、当您打开本App内部下载的文件后，会关联启动第三方App。</li>
        <li>
          4、个推SDK采⽤合并链路技术进⾏技术推送，当⼀个设备有多个APP的推送链路同时活跃时，个推SDK会随机合并成⼀条链路，以达到为您省电省流量的⽬的，当一个设备有离线推送消息待下发的场景时，通过关联启动功能可以下发离线消息，您可以选择开启或关闭这项服务，当您关闭这项服务时，关联启动也同时会关闭，会导致电量和流量消耗加大的同时消息触达率也会降低。
        </li>

        <li>2. 我们如何使用Cookie和同类技术</li>
        <li>
          Cookie是支持服务器端（或脚本）在客户端上储存和检索信息的一种机制。当您在使用部分功能的时候，我们会向您的设备发送一个或多个Cookie或匿名标识符。当您与这些功能产生交互时，我们允许Cookie或者匿名标识符发送给本App服务器。Cookie
          通常包含一些随机生成的字符。运用Cookie技术，我们能够了解您的使用习惯，或帮您判断您账户的安全性。Cookie还可以帮助我们统计流量信息，分析页面设计的有效性。您可以清除软件内保存的所有Cookies。但如果您这么做，可能会对您所使用服务的安全性有一定影响。
        </li>
        <li>
          我们不会将Cookie用于本条款所述目的之外的任何用途。您可以根据自己的偏好管理或删除Cookie。
        </li>
        <li>3. 我们如何存储您的信息</li>
        <li>
          我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。本App所收集的用户个人信息，在互联网线路通过加密传输存放至我们的系统服务器，进行加密存储，我们的机房管理、服务器管理、网络管理以及本App应用安全均严格遵守国家信息系统安全等级保护(二级)。我们仅在本条款所述目的所必需期间和法律法规、监管规定的期间内保存您的信息。除非经您自主选择或遵从相关法律法规要求，我们不会对外提供上述信息，或者将其用于该功能以外的其他用途。
        </li>
        <li>3.1 信息存储的地点</li>
        <li>
          我们会按照法律法规规定，将在中国境内收集和产生的个人信息存储与中国境内。
        </li>
        <li>3.2 信息存储的期限</li>
        <li>一般而言，我们仅为实现目的所必需的时间保留您的个人信息。</li>
        <li>
          当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告形式通知您，在合理的期限内删除您的个人信息或匿名化处理，并立即停止收集个人信息的活动。
        </li>
        <li>
          根据《期货公司互联网开户规则》，使用本App开户过程中上传的视频、音频等重要的原始凭证的保存期限不少于二十年。
        </li>
        <li>4. 我们如何保护您的信息</li>
        <li>
          我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。
        </li>
        <li>
          我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如SSL）、匿名化处理等手段来保护您的个人信息。
        </li>
        <li>
          我们通过不断提升的技术手段加强安装在您设备端的软件安全能力。例如，我们为了安全传输会在您设备本地完成部分信息加密的工作。
        </li>
        <li>
          我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。
        </li>
        <li>
          若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件的扩大，并以推送通知、公告等形式告知您。
        </li>
        <li>5. 我们如何处理您的信息</li>
        <li>
          本条所称“处理”，参照《中华人民共和国个人信息保护法》，包括但不限于：委托处理、共享、转让、公开披露。
        </li>
        <li>
          5.1为了确保服务的安全，帮助我们更好地监控本App应用程序的运行情况，我们可能记录您的相关信息，例如，您使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的任何个人身份信息相结合。
        </li>
        <li>
          5.2
          为了保障服务的稳定性与安全性，我们会将您的信息用于身份验证、安全防范、降低风险、存档和备份用途。
        </li>
        <li>
          5.3
          我们承诺对您的信息进行严格保密，除法律法规、监管部门另有规定或已取得您的授权外，我们不会在未事先获得您明确同意的情况下，共享您的个人信息。
        </li>
        <li>
          5.4
          我们不会未经您的授权将您的个人信息转让给任何公司、组织和个人，但我们需要提示您以下情况：如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并尽最大可能确保新的持有您个人信息的公司、组织继续受本条款的约束，否则我们将要求该公司、组织重新向您征求授权同意。
        </li>
        <li>
          5.5
          <span class="underline"
            >若您选择参与我们开展的抽奖、竞赛等活动，我们可能在公布中奖活动名单时展示中奖者脱敏后的手机号或客户号</span
          >。除前述情况以外，原则上我们不会将您的信息进行公开披露，但上述情况不包括我们已经您另行明确同意或基于法律法规、法律程序、诉讼或政府主管部门强制性要求的情况。
        </li>
        <li>
          5.6
          根据相关法律法规及国家标准，以下情形中，我们可能会在没有事先征询您同意的情况下处理您的个人信息：
        </li>
        <li>1） 与国家安全、国防安全直接相关的；</li>
        <li>2） 与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
        <li>
          4）
          出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </li>
        <li>5） 个人信息主体自行向社会公众公开的个人信息；</li>
        <li>
          6）
          从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </li>
        <li>7）根据个人信息主体要求签订和履行合同所必需的；</li>
        <li>
          8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        </li>
        <li>9） 法律法规规定的其他情形。</li>
        <li>6. 您的权利</li>
        <li>
          在您使用本App期间，为了您可以更加便捷地访问、更正、删除您的个人信息，同时保障你撤回对个人信息处理的同意及注销账号的权利。你可通过手机系统自带功能撤回您对本App的各种隐私信息访问权限，不同手机或不同操作系统版本的操作过程会有不同，请您根据自己手机操作手册进行操作。若您撤回部分或全部权限，本App可能会无法为您提供全部服务，您需要按照您手机操作手册重新开启权限或者重新安装本App后才能正常使用全部功能。我们在产品设计中为您提供了账号注销功能，请参照6.3章节。此外，我们还设置了投诉举报渠道，您的意见将会在十五天内得到响应。
        </li>
        <li>6.1 查看、修改及咨询您的个人信息</li>
        <li>
          您可随时通过“我的”和“业务办理”菜单访问及查看您的个人基本信息及账户信息。若您需要修改您的个人信息，或发现我们处理您的个人信息出错，您有权通过“我的”和
          “业务办理”菜单或公司客服邮箱service@kiiik.com作出修改，并且可以通过本App的在线客服或4008-889-889客服热线咨询您的个人的需求。在收到您的修改个人信息业务后，我们会在15个工作日内完成信息的更正并通知您处理结果。
        </li>
        <li>6.2 删除您的个人信息</li>
        <li>
          若您认为我们使用、采集您个人信息的行为违反了法律、行政法规规定或违反了我们与您的约定或出现错误的，或者发现我们采集、储存您的个人信息有误的，您可以随时联系我们删除您的个人信息或注销您的账号。在收到您删除个人信息的申请后，我们仍需按照监管政策要求的留存时间保存您的信息，当存储期满后，我们将响应您的删除请求，对您的个人信息进行删除或匿名化处理，同时我们会在您申请后的15个工作日内向您反馈业务处理的情况。
        </li>
        <li>6.3 注销您的账户</li>
        <li>（1）注销东航期货APP账户</li>
        <li>
          您可通过本App注销您的账户。注销途径：首先联系4008-889-889客服热线解除账号的实名认证（若未进行实名认证则不需要），其次在东航期货APP首页选择【我的】-登录账户-选择【设置】-【安全设置】-【永久注销账号】。
        </li>
        <li>（2）注销东航期货交易账号</li>
        <li>
          您可通过本App注销您的在我司开立的期货交易账户。注销途径：使用与交易账户绑定手机号登录APP，首页选择【业务办理】页面选择【账户销户】业务提交销户申请。请注意，为了保护您或他人的合法权益，我们会根据监管要求及您对我们产品的使用情况判断是否支持您的注销请求，并不会检验与注销功能无关的条件（例如您在账户中仍有期货持仓的情况下，将无法注销账户）。
        </li>
        <li>
          在收到您注销账户的业务申请后，我们会在15个工作日内完成业务办理并通知您处理结果。您删除您的信息或注销账户后，我们将不再收集、使用或共享与您该账户相关的个人信息，但我们仍需按照监管政策要求的留存时间保存您的信息，且在该保存的时间内依法配合有权机关的查询。当存储期限满足监管要求后，我们将会响应您的删除请求，对您的个人信息进行删除或匿名化处理。
        </li>
        <li>
          6.4
          在以下情形中，根据法律法规要求，我们将无法响应您更正、删除、注销信息的请求：
        </li>
        <li>（1）如果我们处理个人信息的行为违反法律法规；</li>
        <li>（2）如果我们处理个人信息的行为违反了与你的约定；</li>
        <li>（3）如果我们终止服务及运营。</li>

        <li>6.5 撤回同意隐私政策</li>
        <li>
          请您理解，本APP每个业务功能均需要手机一些基本的个人信息才能得以完成。如您需要撤回同意隐私政策条款及您的个人信息，您可以卸载东航期货APP、注销您的账户或联系我司官方客服电话4008-889-889删除您的个人信息。
        </li>

        <li>6.6 响应您的上述请求</li>
        <li>
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我司可能会先要求您验证自己的身份，然后再处理您的请求。我司将在收到您的要求后，根据相关法律法规的要求及时处理并将处理结果于15个自然日内或法律法规要求的时限内（如有）反馈您。如您不满意，还可以拨打我司4008-889-889客服热线进行反馈。
        </li>
        <li>7. 未成年人保护</li>
        <li>
          1.本条款所指未成年人是根据《中华人民共和国未成年人保护法》规定的未满十八周岁的公民。
        </li>
        <li>
          2.我们的业务主要面向十八周岁以上公民使用，根据相关法律法规的规定，若您是十四周岁以下的未成年人，在使用本App前，应事先取得您的家长或法定监护人的书面同意。
        </li>
        <li>
          3.如果您是已满十四周岁、未满十八周岁的未成年人，建议请您的监护人阅读本条款，并在取得您的监护人同意的前提下向我们提供您的相关信息以便使用我们除商品期货经纪、金融期货经纪、期货投资咨询、资产管理之外的服务。对于经监护人同意而收集您的信息的情况，我们只会在受到法律允许、监护人明确同意或者保护您的权益所必要的情况下使用或公开披露此信息。
        </li>
        <li>
          4.东航期货非常重视对未成年人个人信息的保护，若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本章节第9条中的联系方式与我们联系。
        </li>
        <li>8. 通知和变更</li>
        <li>
          我们可能会适时对本条款进行修订。当条款发生变更时，我们会在您登录及版本更新时以弹窗的形式向您展示变更后的指引。请您注意，只有在您点击弹窗中的同意按钮后，我们才会按照更新后的指引收集、使用、存储您的个人信息。您可以在本App中“我的-设置-风险提示和隐私条款”中随时查看本条款。
        </li>
        <li>9. 与我们联系</li>
        <li>您对本App有任何意见或建议，可通过如下方式联系我们：</li>
        <li>（1）客服热线4008-889-889</li>
        <li>（2）客服邮箱service@kiiik.com</li>
        <li>（3）东航期货App的在线客服功能</li>
        <li>对本条款的问题，您可以将您的问题寄到如下地址：</li>
        <li>
          上海市长宁区友乐路299号东虹桥中心T7座三楼 东航期货有限责任公司
          合规及风险管理部（收）
        </li>
        <li>邮编：200335</li>
        <li>
          我们将尽快审核所涉及的问题，并在验证您的用户身份后的十五天内予以回复。
        </li>
      </ul>

      <ul>
        <li class="dis-flex">
          <i class="left-line"></i>
          <h4 class="flex-1">四、我司拥有对上述条款的最终解释权。</h4>
        </li>
        <li class="text-r">东航期货有限责任公司</li>
      </ul>
    </main>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {}
  },
  methods: {
    godsf() {
      window.scrollTo(0, 0)
      this.$router.push('/dsfxxgxqd')
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

html {
  font-size: 10px;
  word-wrap: break-word;
}

body {
  line-height: 1.6;
  font-size: 1.6rem;
}
td,
th {
  text-align: center;
  padding: 10px 5px;
}

.appInfo {
  margin-bottom: 34px;
}

ul,
li {
  list-style: none;
}
.dis-flex {
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: space-between;
}

.flex-1 {
  flex: 1;
}

ul,
ol,
dl,
ul li {
  padding: 0;
  margin: 0;
  list-style: none;
}

/*东航期货网站复制*/
a {
  text-decoration: none;
}

main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px;
  line-height: 30px;
  font-size: 14px;
  color: #3f3f3f;
  word-wrap: break-word;
}

h4 {
  font-weight: normal;
  font-size: 15px;
  color: #2e2e2e;
}

.left-line {
  display: block;
  width: 5px;
  height: 20px;
  margin-right: 15px;
  background-color: #f65c5c;
  border-radius: 100px;
}

.text-r {
  text-align: right;
}

.underline {
  text-decoration: underline;
  font-weight: bold;
}

.break-all {
  word-break: break-all;
}
.common_div div {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ececec;
  padding: 4px;
}
.special-box div:nth-child(1) {
  border: 1px solid #ececec;
}

.special-box div,
.special-box p {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.special-box p {
  width: 100%;
  height: 100%;
  border: 1px solid #ececec;
  padding: 4px;
}
.personal-box p {
  height: 200px;
}

.login-box p {
  height: 150px;
}

.account-header p {
  height: 80px;
}
.account-contain p:nth-child(1),
.account-contain p:nth-child(2) {
  height: 80px;
}
.account-contain p:nth-child(3) {
  flex: 1;
}

.gnyw-header p {
  height: 170px;
}
.gnyw-header p:nth-child(1) {
  height: 140px;
}
.gnyw-header p:nth-child(2) {
  height: 100px;
}
.forgot-pwd p {
  height: 120px;
}
.forgot-pwd p:nth-child(1) {
  height: 180px;
}
.forgot-contain p:nth-child(1) {
  height: 180px;
}
.forgot-contain p:nth-child(2) {
  flex: 1;
}
.gnye-two p {
  height: 100px;
}
.gnye-two p:nth-child(1),
.gnye-two p:nth-child(2) {
  height: 220px;
}
.gnye-two p:nth-child(5) {
  height: 150px;
}
.width_20 {
  width: 20%;
}
.flex_1 {
  flex: 1;
}
.width_30 {
  width: 30%;
}
.red {
  color: red;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// dhqh.vue?2aa45111